import React, { useEffect } from 'react';
import { Box, CardContent, Typography } from '@mui/material';
import { alpha } from '@mui/system';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';
import { listOrganisationDailyUpdates } from '../../../../redux/slices/daily-updates';
import { RoleName } from '../../../../types/user';
import { ModernCard, CardHeader, COLORS } from '../../../../pages/Organisation/DailyUpdates/utils';
import VerifierSkeleton from '../../atoms/DailyUpdates/VerifierSkeleton';

export const CustomStatusBadge = ({ color, label }: { color: string; label: number | string }) => (
	<Box
		sx={{
			borderRadius: '6px',
			backgroundColor: alpha(color, 0.15),
			color: color,
			fontWeight: 600,
			fontSize: '0.75rem',
			height: '24px',
			padding: '0 8px',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center'
		}}
	>
		{label}
	</Box>
);

const VerifierDU = () => {
	const dispatch = useAppDispatch();
	const [verifierDU, organisation, user] = useAppSelector((state) => [
		state.dailyUpdates.dailyUpdates?.[RoleName.Verifier],
		state.organisation.current,
		state.user.currentUser
	]);

	const organisationId = organisation?.id || user?.roles?.find((r) => r.organisationId)?.organisationId;

	useEffect(() => {
		organisationId &&
			user?.id &&
			dispatch(
				listOrganisationDailyUpdates({
					organisationId,
					roleName: RoleName.Verifier,
					status: null,
					dailyUpdates: true,
					lastLoggedOut: localStorage.getItem(`lastLogout_${user?.id}`) || undefined
				})
			);
	}, [dispatch, organisationId, user?.id]);

	if (!verifierDU) {
		return <VerifierSkeleton />;
	}

	return (
		<Box
			sx={{
				p: 3,
				maxWidth: '1400px',
				margin: '0 auto',
				backgroundColor: alpha(COLORS.neutral, 0.5),
				borderRadius: '24px'
			}}
		>
			{/* Stats Overview Cards */}
			<Box sx={{ display: 'flex', gap: 3, mb: 4 }}>
				{/* New Verification Requests Card */}
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Typography variant="h6" sx={{ fontWeight: 600, color: COLORS.text }}>
							New Verification Requests
						</Typography>
					</CardHeader>
					<CardContent sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<CustomStatusBadge color={COLORS.success} label={verifierDU.newVerificationRequests} />
					</CardContent>
				</ModernCard>

				{/* Pending Verification Requests Card */}
				<ModernCard sx={{ flex: 1 }}>
					<CardHeader>
						<Typography variant="h6" sx={{ fontWeight: 600, color: COLORS.text }}>
							Pending Verification Requests
						</Typography>
					</CardHeader>
					<CardContent sx={{ p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<CustomStatusBadge color={COLORS.warning} label={verifierDU.pendingVerificationRequests} />
					</CardContent>
				</ModernCard>
			</Box>
		</Box>
	);
};

export default VerifierDU;
